import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap5';
import * as Yup from 'yup';
import { Formik, Form as FormikForm } from 'formik';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import SubmitButton from 'components/Widgets/SubmitButton';
import { useContext as useUsersContext } from 'components/Users/Context';
import useLearnerStyleQuestions from 'components/Common/LearnerStyleQuestions/Hooks/useLearnerStyleQuestions';
import Actions from 'components/Members/Actions';

import Field from './Field';

export default function Index({ submitText, afterSubmit, previousLink }) {
  const { state: stateUsers } = useUsersContext();
  const member = stateUsers.user?.attributes?.specific;
  const progressData = JSON.parse(localStorage.getItem('learningStyleProgressData') || '{}');
  const learnerStyleQuestions = useLearnerStyleQuestions();

  const formSchema = Yup.object().shape({
  });

  const onSubmitHundler = (values, { setSubmitting, setErrors }) => {
    const params = {
      learning_style: Object.entries(values).map((val) => `${val[0]}_${val[1]}`),
    };

    Actions.update(
      member.id,
      params,
      (_updatedMember) => {
        localStorage.removeItem('learningStyleProgressData');
        setSubmitting(false);
        afterSubmit();
      },
      (errors) => {
        const newErrors = {};

        errors.forEach((item) => {
          newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
        });
        setErrors(newErrors);
        setSubmitting(false);
      },
    );
  };

  const scrollToNextQuestion = (currentItem) => {
    const itemWrapper = currentItem.closest('.scrollable-item');
    itemWrapper.classList.add('disabled');

    const nextItem = itemWrapper.nextSibling;
    if (nextItem) {
      nextItem.classList.remove('disabled');

      const scrollableContent = currentItem.closest('.scrollable-content');
      const itemHeight = itemWrapper.getBoundingClientRect().height;
      scrollableContent.style.transform += `translateY(-${itemHeight}px)`;
    }
  };

  useEffect(() => {
    if (member && learnerStyleQuestions) {
      // Move to current, non-answered question.
      document.querySelectorAll('.scrollable-item').forEach((item) => {
        const input = item.querySelector('.form-check-input');

        if (input && Object.keys(progressData).includes(input.name)) {
          scrollToNextQuestion(input);
        }
      });
    }
  }, [member, learnerStyleQuestions]);

  return (
    <Formik
      validationSchema={formSchema}
      initialValues={progressData}
      onSubmit={onSubmitHundler}
    >
      {({ values, isSubmitting }) => (
        <FormikForm className="learning-style-form form-with-counter border-top border-light" noValidate="">
          {member && learnerStyleQuestions ? (
            <>
              <section>
                <Row>
                  <Col
                    lg={{ span: 10, offset: 1 }}
                    xl={{ span: 8, offset: 2 }}
                    className="scrollable-wrapper"
                  >
                    <div className="scrollable-content">
                      {learnerStyleQuestions.map((learnerStyleQuestion, index) => (
                        <Field
                          key={learnerStyleQuestion.id}
                          item={learnerStyleQuestion}
                          active={index === 0}
                          afterClick={(target, value) => {
                            // Save current progress in localStorage object.
                            const data = {
                              ...JSON.parse(localStorage.getItem('learningStyleProgressData') || '{}'),
                              [learnerStyleQuestion.id]: value,
                            };
                            localStorage.setItem('learningStyleProgressData', JSON.stringify(data));

                            scrollToNextQuestion(target);
                          }}
                        />
                      ))}
                    </div>
                  </Col>
                </Row>
              </section>

              <footer className={previousLink ? 'd-flex justify-content-between' : ''}>
                {previousLink && (
                  <Link
                    to={previousLink}
                    className={`btn btn-outline-primary ${isSubmitting && 'disabled'}`}
                  >
                    Previous
                  </Link>
                )}

                <SubmitButton
                  loading={isSubmitting}
                  disabled={
                    learnerStyleQuestions.length !== Object.keys(values).filter((val) => val !== undefined).length
                  }
                >
                  {submitText}
                </SubmitButton>
              </footer>
            </>
          ) : (
            <section>
              <LoadingPlaceholder text="Loading..." />
            </section>
          )}
        </FormikForm>
      )}
    </Formik>
  );
}

Index.propTypes = {
  submitText: PropTypes.string,
  afterSubmit: PropTypes.func.isRequired,
  previousLink: PropTypes.string,
};

Index.defaultProps = {
  submitText: 'Save',
  previousLink: undefined,
};
